<!-- src/app/pages/newsroom/newsroom.component.html -->
<section class="newsroom-page">

  <!-- HERO -->
  <div class="newsroom-hero">
    <div class="newsroom-hero__content">
      <div class="newsroom-eyebrow">Campaign Updates</div>
      <h1>Newsroom</h1>
      <p>The latest press releases and news from the Lydia Christensen for U.S. Senate campaign.</p>
    </div>
  </div>

  <!-- IN THE NEWS -->
  <div class="in-the-news">
    <div class="newsroom-body">
      <div class="in-the-news__header">
        <div class="in-the-news__eyebrow">Media Coverage</div>
        <h2>In the News</h2>
      </div>
      <div class="media-cards">

  <!-- July 2026 -->
  <a href="https://independentpoliticalreport.com/2026/07/michigan-libertarian-senate-candidate-faces-criticism-from-lnc-members-over-policy-views/"
     target="_blank" rel="noopener noreferrer" class="media-card">
    <div class="media-card__outlet">
      <span class="media-card__outlet-name">Independent Political Report</span>
      <span class="media-card__date">July 2026</span>
    </div>
    <h3 class="media-card__title">Michigan Libertarian Senate Candidate Faces Criticism From LNC Members Over Policy Views</h3>
    <p class="media-card__desc">
      Independent Political Report covers internal Libertarian Party debate over Lydia Christensen's policy positions as the party's Michigan U.S. Senate nominee.
    </p>
    <span class="media-card__cta">Read Article <span>→</span></span>
  </a>

  <!-- July 2026 -->
  <a href="https://www.facebook.com/reel/1037982088640541"
     target="_blank" rel="noopener noreferrer" class="media-card">
    <div class="media-card__outlet">
      <span class="media-card__outlet-name">My UP Now</span>
      <span class="media-card__date">July 2026</span>
    </div>
    <h3 class="media-card__title">Lydia Christensen's Campaign, Featured in a Facebook Reel</h3>
    <p class="media-card__desc">
      My UP Now covers Lydia Christensen's Libertarian U.S. Senate campaign in a short-form video feature.
    </p>
    <span class="media-card__cta">Watch Reel <span>→</span></span>
  </a>

  <!-- May 2025 -->
  <a href="https://www.yourdailyglobe.com/story/2025/05/15/news/ironwood-gets-push-for-sanctuary-city-status/19403.html"
     target="_blank" rel="noopener noreferrer" class="media-card">
    <div class="media-card__outlet">
      <span class="media-card__outlet-name">The Globe</span>
      <span class="media-card__date">May 2025</span>
    </div>
    <h3 class="media-card__title">Ironwood Gets Push for Sanctuary City Status</h3>
    <p class="media-card__desc">
      The Globe reports on Lydia Christensen's proposal for an LGBTQ+ sanctuary-city policy in Ironwood and the CARE framework presented to the city commission.
    </p>
    <span class="media-card__cta">Read Article <span>→</span></span>
  </a>

  <!-- 2025 -->
  <a href="https://michiganindependent.com/Politics/candidates-running-for-michigans-open-senate-seat-in-2026"
     target="_blank" rel="noopener noreferrer" class="media-card">
    <div class="media-card__outlet">
      <span class="media-card__outlet-name">The Michigan Independent</span>
      <span class="media-card__date">2025</span>
    </div>
    <h3 class="media-card__title">These Are the Candidates Running for Michigan’s Open Senate Seat in 2026</h3>
    <p class="media-card__desc">
      The Michigan Independent profiles the candidates for Michigan's open U.S. Senate seat, including Lydia Christensen and her campaign priorities.
    </p>
    <span class="media-card__cta">Read Article <span>→</span></span>
  </a>

  <!-- October 2025 -->
  <a href="https://www.miningjournal.net/news/front-page-news/2025/10/senatorial-candidates-lydia-christensen"
     target="_blank" rel="noopener noreferrer" class="media-card">
    <div class="media-card__outlet">
      <span class="media-card__outlet-name">Mining Journal</span>
      <span class="media-card__date">October 2025</span>
    </div>
    <h3 class="media-card__title">Senatorial Candidates: Lydia Christensen</h3>
    <p class="media-card__desc">
      The Mining Journal covers Lydia Christensen's candidacy for U.S. Senate in Michigan.
    </p>
    <span class="media-card__cta">Read Article <span>→</span></span>
  </a>

</div>
    </div>
  </div>

  <!-- BODY -->
  <div class="newsroom-body">
    <div class="newsroom-container">
      <div class="newsroom-main">
        <app-press-release-list></app-press-release-list>
      </div>
      <aside class="newsroom-sidebar">
        <app-newsletter-signup></app-newsletter-signup>

        <div class="sidebar-media-card">
          <div class="sidebar-media-card__icon">📞</div>
          <h3>Media Inquiries</h3>
          <p>For interview requests, press credentials, or media assets:</p>
          <a href="mailto:senator@lydialynnchristensen.com" class="sidebar-media-card__email">senator&#64;lydialynnchristensen.com</a>
          <a routerLink="/press" class="sidebar-media-card__link">View Press Kit →</a>
        </div>

        <app-press-release-form *ngIf="isAuthenticated"></app-press-release-form>
      </aside>
    </div>
  </div>

</section>
